<template>
    <div v-if="status === 'loaded'">
        <div class="admin-page text-center">
            <the-nav>
                <h1>Entidades</h1>

                <div class="buttons-container">
                    <button class="btn btn-danger icon-wrapper"
                            @click="emptyFilters">
                        <i class="uq-icon bi-filter"></i>&nbsp;Limpiar filtros
                    </button>

                    <button class="btn btn-download icon-wrapper"
                            v-if="can('export.entities')"
                            @click="downloadEntities(filters)">
                        <i class="uq-icon bi-download"></i>
                    </button>

                    <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-entity'"
                            title="Nuevo usuario" v-if="can('entity.store')">
                        <span>Añadir entidad</span>
                    </button>
                </div>
            </the-nav>

            <div class="row form-container" v-if="can('entity.index')">
                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nombre: </label>
                        <input type="text" class="form-control" aria-label="Nombre" v-model="filters.name"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">NIF: </label>
                        <input type="text" class="form-control" aria-label="NIF" v-model="filters.nif" @input="search"/>
                    </div>
                </div>
            </div>

            <div class="admin-main">
                <v-table :meta="entities.meta" :pagination="entities.links.pagination" @pageChanged="pageChanged" v-if="status === 'loaded'">
                    <template v-slot:header>
                        <th>Nombre</th>
                        <th>Nombre corto</th>
                        <th>NIF</th>
                        <th class="fit" colspan="2">Acciones</th>
                    </template>

                    <template v-slot:body>
                        <tr v-for="entity in entities.data">
                            <td>{{ entity.name }}</td>
                            <td>{{ entity.short_name }}</td>
                            <td>{{ entity.nif }}</td>

                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-show" @click="showEntity(entity)"
                                            v-if="can('entity.show')">
                                        <i class="uq-icon bi-eye"></i>
                                    </button>

                                    <button class="btn btn-edit" @click="editEntity(entity)"
                                            v-if="can('entity.update')">
                                        <i class="uq-icon bi-pencil"></i>
                                    </button>

<!--                                    <button class="btn btn-delete" @click="deleteEntity(entity)"-->
<!--                                            v-if="can('entity.destroy')">-->
<!--                                        <i class="uq-icon bi-trash"></i>-->
<!--                                    </button>-->
                                </div>
                            </td>

                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-danger" @click="goToCreateExpedient(entity.id)"
                                            v-if="can('expedient.store')">
                                        Crear expediente
                                    </button>

                                    <button class="btn btn-warning" @click="goToEntityExpedients(entity.id)"
                                            v-if="can('expedient.index')">
                                        Ver expedientes
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!entities.data">
                            <td colspan="222222">No hay entidades</td>
                        </tr>
                    </template>
                </v-table>

                <div v-if="status === 'loading'">
                    <div class="loader-container">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <entitites-list-show-modal v-if="modalToShow === 'show-entity'" :entity="selectedEntity"
                               @closed="modalToShow = null"></entitites-list-show-modal>
    <entitites-list-edit-modal v-if="modalToShow === 'edit-entity'" :entity="selectedEntity"
                               @closed="modalToShow = null; loadEntities()"></entitites-list-edit-modal>
    <entities-list-delete-modal v-if="modalToShow === 'delete-entity'" :entity="selectedEntity"
                                @closed="modalToShow = null; loadEntities()"></entities-list-delete-modal>
    <entities-list-add-modal v-if="modalToShow === 'add-entity'"
                             @closed="modalToShow = null; loadEntities()"></entities-list-add-modal>
</template>

<script>
import EntitiesListAddModal from "./parts/EntitiesListAddModal";
import EntititesListShowModal from "./parts/EntitiesListShowModal";
import EntititesListEditModal from "./parts/EntitiesListEditModal";
import EntitiesListDeleteModal from "./parts/EntitiesListDeleteModal";
import {can} from "../../helpers/Permissions";
import router from "../../router";
import {downloadEntitiesXLSX} from "../../helpers/Exports";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import {getEntitiesPaginated} from "../../helpers/requests/RequestsEntities";
import TheNav from "../layouts/TheNav";
import VPagination from "../general/VPagination";
import {filtersToQueryParameters, setQueryParameters} from "../../helpers/Url";
import VTable from "../general/VTable";


export default {
    name: "entities",
    components: {
        VPagination,
        TheNav,
        EntitiesListDeleteModal,
        EntititesListEditModal,
        EntititesListShowModal,
        EntitiesListAddModal,
        VTable
    },
    setup() {
        return {
            can,
            downloadEntitiesXLSX,
        }
    },
    data() {
        return {
            status: 'loading',
            entities: [],
            entity: null,
            selectedEntity: null,
            modalToShow: null,
            user_permissions: window.permissions,

            do_search: true,

            filters: {
                name: '',
                nif: '',
                page: 1,
            },
            timers: {
                search: '',
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user.userLogged;
        }
    },
    async mounted() {
        window.$ = window.jQuery = require('jquery');

        // Read query params to form filters
        await this.setQueryParametersAsFilters();
        await this.doSearch();
        this.status = 'loaded';
    },
    watch: {
        $route(to, from) {
            // Apply only if we are operating over the same view
            if (to.name === from.name) {
                // TODO: Watch this and just only change url query parameters when methods fire something? This will do the rest
                this.setQueryParametersAsFilters();

                // We force it to not search because of a two-requests problem
                if (this.do_search === true) {
                    this.doSearch();
                }

                this.do_search = true;
            }
        }
    },
    methods: {
        downloadEntities(filters) {
            this.$store.dispatch('app/setToastMessage', 'Procesando la descarga...');
            downloadEntitiesXLSX(filters);
        },
        async doSearch() {
            this.do_search = false;
            await this.setFiltersAsQueryParameters();
            await this.loadEntities();
        },
        emptyFilters() {
            this.filters = {
                name: '',
                nif: '',
                page: 1,
            };

            this.doSearch();
        },
        /**
         * Detects any query parameter in the url and loads it in the filters (if available)
         *
         * @returns {Promise<void>}
         */
        async setQueryParametersAsFilters() {
            let query_parameters = router.currentRoute.value.query;

            if (query_parameters.name) {
                this.filters.name = query_parameters.name;
            } else {
                this.filters.name = '';
            }
            if (query_parameters.nif) {
                this.filters.nif = query_parameters.nif;
            } else {
                this.filters.nif = '';
            }
            if (query_parameters.page) {
                this.filters.page = query_parameters.page;
            } else {
                this.filters.page = 1;
            }
        },
        /**
         * Sets the local filters as url query parameters.
         */
        setFiltersAsQueryParameters() {
            setQueryParameters('entity.index', this.filters);
        },
        async loadEntities() {
            let query = filtersToQueryParameters(this.filters);

            this.entities = await getEntitiesPaginated(query);
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async pageChanged(page) {
            this.filters.page = page;
            await this.doSearch();
        },
        showEntity(entity) {
            this.modalToShow = 'show-entity';
            this.selectedEntity = entity;
        },
        editEntity(entity) {
            this.modalToShow = 'edit-entity';
            this.selectedEntity = entity;
        },
        deleteEntity(entity) {
            this.modalToShow = 'delete-entity';
            this.selectedEntity = entity;
        },
        addEntity() {
            this.modalToShow = 'add-entity';
        },
        async goToCreateExpedient(entity_id) {
            let query = {
                createExpedient: 'true',
                entity: entity_id + '',
            }

            await router.push({
                name: 'expedient.index',
                query: query
            });
        },
        async goToEntityExpedients(entity_id) {
            let query = {
                entity: entity_id + '',
            }

            await router.push({
                name: 'expedient.index',
                query: query
            });
        }
    },
    unmounted() {
        delete window.$;
        delete window.jQuery;
    }
}
</script>
